@if (loadingService.loading$ | async; as loading) {
  @if (loading?.active == true) {
    <div class="spinner-background text-center">
      @if (loading.message) {
        <div class="spinner-message">
          <i class="pi pi-spin pi-spinner"></i>
          <span>{{ loading.message }}</span>
        </div>
      }
    </div>
  }
}
